module.exports = __webpack_public_path__ + "static/img/13.8164786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/13.png
// module id = LS6J
// module chunks = 0